import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import { type EffectCtx, effectRegistry } from './effectRegistry';
import type { UiEffect } from './uiEffect.schema';

type UiEffectHandler = (effect: UiEffect, ctx: EffectCtx) => Promise<void> | void;

export const useUiEffectHandler = () => {
  const history = useHistory();

  return useCallback(
    (effect: UiEffect) => {
      const ctx: EffectCtx = {
        navigate: (to) => history.push(to),
      };

      const handler = effectRegistry[effect.kind] as UiEffectHandler;

      return handler(effect, ctx);
    },
    [history],
  );
};
